export default __webpack_public_path__ + "static/ISP_logo-ac0c75778680a68d0c7aa297d6e3e305.jpg";